<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#F2C94C"/>
    <path d="M11.8277 18.6711L10.4135 20.0853C7.64689 18.5737 6.39438 17.3861 4.7566 14.4285L6.17082 13.0142C7.78433 15.8897 9.08603 17.0934 11.8277 18.6711ZM15.3703 8.05742L9.70635 13.7213L11.1206 15.1356L16.7845 9.47164L18.9058 11.593L18.8987 5.94317L13.249 5.9361L15.3703 8.05742Z" fill="#F2F2F2"/>
  </svg>
</template>

<script>
export default {
  name: "NivelMedio"
}
</script>

<style scoped>

</style>
